<template>
  <div class="mobile-nav-wrap">
<!--    <NuxtImg v-if="!isSearchInputExpand"
             @click="goHome({})"
             class="logo"
             format="webp"
             quality="80"
             loading="lazy"
             width="154"
             src="/logo/osn-zh-horizon.png"
             alt="logo"/>-->
    <img @click="goHome({})"
         class="logo"
         src="@/assets/image/logo/osn-zh-horizon.png"
         alt="logo"
    />
    <div class="flex items-center flex-1 min-w-0 ml-[16px]">
      <div class="keyword-search">
        <input type="text"
               v-model="searchKeyword"
               :placeholder="$t('placeholder.keyword')"
               @input="handleInput"
               @keyup.enter="handleSpaceKeywordSearch()"
               ref="searchInput">
        <img class="search-btn"
             :src="searchIcon"
             @click="handleSpaceKeywordSearch()"
             alt="">
      </div>
      <img @click="handleSideBar"
           class="side-bar-btn"
           src="@/assets/image/icon/menu/menu.svg"
           alt="">
    </div>

  </div>
</template>
<script setup>
import {ref, computed} from 'vue'
import {useGoTo} from "@/composables/useGoTo";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useDebounce} from "~/composables/useDebounce";
import arrowLeft from "@/assets/image/icon/space/arrow_left.svg";
import manageSearch from "@/assets/image/icon/menu/manage_search.svg";


const {go, goHome} = useGoTo()
const {handleSearchWithStore} = useSearchWithStore()
const searchQueryStore = useSearchQueryStore()
const searchKeyword = ref('');
const searchInput = ref(null)
const {debounce} = useDebounce()

const props = defineProps({
  handleSideBar: {
    type: Function
  }
})

const searchIcon = computed(() => {
  return searchKeyword.value ? arrowLeft : manageSearch;
});

function handleSpaceKeywordSearch() {
  if (!searchKeyword.value) {
    return
  }
  searchQueryStore.initQueryDate()
  searchQueryStore.setKeyword(searchKeyword.value)
  handleSearchWithStore()
  go('/search-result')
  // searchQueryStore.clearKeyword()
}

const debouncedSearch = debounce(() => {
  /*searchQueryStore.initQueryDate()
  searchQueryStore.setKeyword(searchKeyword.value)
  handleSearchWithStore()*/
  handleSpaceKeywordSearch()
}, 500);

function handleInput() {
  // mobile 輸入不自動搜尋
  // debouncedSearch();
}

</script>

<style scoped
       lang="scss">
.mobile-nav-wrap {
  @apply px-[20px] h-[66px] flex justify-between items-center w-full;
  img.logo {
    @apply h-[30px] flex-shrink-0;
  }

  .keyword-search {
    @apply flex-1 min-w-0 mr-[16px] px-[16px] h-[40px] bg-osn-grey-04 rounded-full flex items-center;
    input {
      @apply flex-1 min-w-0 bg-transparent text-osn-grey-02 text-[14px] outline-none border-none;
    }

    img.search-btn {
      @apply flex-shrink-0 ml-2 w-[20px] cursor-pointer;
    }
  }

  .side-bar-btn {
    @apply flex-shrink-0 w-[24px] h-[24px];
  }
}

</style>
